// extracted by css-extract-rspack-plugin
export default {"page":"kKbKy7T34wNjH_iU","content":"ijnghETyGqUqTjtC"};